import { render, staticRenderFns } from "./TagsDropdownItem.component.vue?vue&type=template&id=01f81df8&scoped=true&"
import script from "./TagsDropdownItem.component.vue?vue&type=script&lang=js&"
export * from "./TagsDropdownItem.component.vue?vue&type=script&lang=js&"
import style0 from "./TagsDropdownItem.component.vue?vue&type=style&index=0&id=01f81df8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f81df8",
  null
  
)

export default component.exports